export const DISABLE_USER_REQUEST = 'DISABLE_USER_REQUEST';

export const disableUserRequest = ( password, validTo ) => ({
    type: DISABLE_USER_REQUEST,
    payload: { password, validTo }
});
